export default __webpack_public_path__ + "static/media/ic_fantom.c2866f32.svg";